import { render, staticRenderFns } from "./SampleSmsModal.vue?vue&type=template&id=3741147d"
import script from "./SampleSmsModal.vue?vue&type=script&lang=js"
export * from "./SampleSmsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports